import { z } from 'zod';
export const LoggingConfigSchema = z.object({
    enableConsole: z.boolean().optional(),
    enableFile: z.boolean().optional(),
    logDir: z.string().optional(),
    logFileName: z.string().optional(),
});
export const SecurityConfigSchema = z.object({
    enableInputValidation: z.boolean().default(true),
    allowedPaths: z.array(z.string()).default([]),
    maxPromptLength: z.number().positive().default(100000),
    maxExecutionTime: z.number().positive().default(3600000),
    enableSandboxing: z.boolean().default(true),
    trustedAgents: z.array(z.string()).default([]),
});
export const ServicesConfigSchema = z.object({
    forgeService: z.object({
        url: z.string().default('http://localhost:8881'),
        port: z.number().default(8881),
    }).optional(),
    toolsService: z.object({
        url: z.string().default('http://localhost:8882'),
        port: z.number().default(8882),
    }).optional(),
    middlewareService: z.object({
        url: z.string().default('http://localhost:8883'),
        port: z.number().default(8883),
    }).optional(),
    ideService: z.object({
        url: z.string().default('http://localhost:8884'),
        port: z.number().default(8884),
    }).optional(),
    logService: z.object({
        url: z.string().default('https://logs.qwickforge.com'),
    }).optional(),
});
export const QwickForgeCoreConfigSchema = z.object({
    logLevel: z.enum(['debug', 'info', 'warn', 'error']).optional(),
    logging: LoggingConfigSchema.optional(),
    security: SecurityConfigSchema.optional(),
    services: ServicesConfigSchema.optional(),
});
//# sourceMappingURL=configuration-schemas.js.map